import React, { useEffect, useRef, useState } from 'react';
import { ACTIONS, COMMAND_CATEGORIES } from '../config/actionRegistry';
import './CommandCenter.css';

/**
 * CLARA-COMMAND-CENTER-TRUTH-1
 *
 * Das Command Center besitzt keine eigene Ausführungslogik. Es bietet nur
 * visuelle Einstiege in exakt dieselben serverseitigen Capabilities, die Clara
 * auch aus Freitext und Voice heraus nutzt.
 */
export default function CommandCenter({ onTrigger, disabled = false }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);

  const trigger = (actionId) => {
    const action = ACTIONS[actionId];
    if (!action || disabled) return;
    onTrigger?.(action);
    setIsOpen(false);
  };

  return (
    <div ref={containerRef} className="command-center-container">
      {!isOpen ? (
        <button
          className="command-pill"
          onClick={() => setIsOpen(true)}
          disabled={disabled}
          title="Command Center öffnen"
        >
          <span className="pill-icon">⚡</span>
          <span className="pill-text">Command Center</span>
        </button>
      ) : (
        <div className="command-bar" aria-label="Clara Command Center">
          <div className="command-header">
            <div>
              <h3 className="command-title">Command Center</h3>
              <p className="text-xs text-gray-400 mt-1">Echte Clara-Funktionen · Schreiben nur nach Freigabe</p>
            </div>
            <button className="command-close" onClick={() => setIsOpen(false)} title="Schließen">✕</button>
          </div>
          <div className="command-buttons">
            {COMMAND_CATEGORIES.map(category => (
              <div key={category.id} style={{ marginBottom: '12px' }}>
                <div style={{
                  fontSize: '11px', fontWeight: '600', color: '#9ca3af', marginBottom: '6px',
                  textTransform: 'uppercase', letterSpacing: '0.5px'
                }}>
                  {category.label}
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  {category.actionIds.map(actionId => {
                    const action = ACTIONS[actionId];
                    return (
                      <button
                        key={action.id}
                        className="command-button"
                        onClick={() => trigger(action.id)}
                        disabled={disabled}
                        title={action.description}
                      >
                        <span style={{ fontSize: '16px', marginRight: '8px' }}>{action.icon}</span>
                        <span>{action.label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
          <div className="text-xs text-gray-500 pt-1">
            Weitere historische Aktionen sind derzeit nicht produktiv freigegeben.
          </div>
        </div>
      )}
    </div>
  );
}
